import type { ServiceType } from '@/pages/home/hooks/useWhatsApp';

interface WhoWeServeProps {
  onOpenWhatsApp: (service?: ServiceType) => void;
}

export default function WhoWeServe({ onOpenWhatsApp }: WhoWeServeProps) {
  const cards: { icon: string; title: string; description: string; service: ServiceType }[] = [
    {
      icon: 'ri-building-2-line',
      title: 'Fabrika & Üretim Tesisleri',
      description: 'Yoğun çalışma düzenine uygun planlı toplu yemek çözümleri.',
      service: 'Fabrika',
    },
    {
      icon: 'ri-hammer-line',
      title: 'İnşaat & Şantiye',
      description: 'Sahadaki ekipleriniz için düzenli ve operasyonunuza uygun yemek hizmeti.',
      service: 'İnşaat / Şantiye',
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Şirket & Ofis',
      description: 'Çalışanlarınız için profesyonel kurumsal catering çözümleri.',
      service: 'Şirket / Ofis',
    },
    {
      icon: 'ri-school-line',
      title: 'Okul & Kurumlar',
      description: 'Düzenli ve planlı toplu yemek hizmeti.',
      service: 'Okul / Kurum',
    },
    {
      icon: 'ri-movie-line',
      title: 'Film & Dizi Setleri',
      description: 'Yoğun prodüksiyon temposuna uygun catering hizmeti.',
      service: 'Film / Dizi Seti',
    },
    {
      icon: 'ri-calendar-event-line',
      title: 'Organizasyonlar',
      description: 'Etkinlik ve organizasyon ihtiyaçlarınıza uygun catering çözümleri.',
      service: 'Organizasyon',
    },
  ];

  return (
    <section id="kimlere" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-6xl mx-auto">
        <div className="reveal text-center mb-12 md:mb-16">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
            HER İŞLETMEYE AYNI ÇÖZÜM DEĞİL
          </h2>
          <p className="font-body text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            Farklı çalışma ortamlarının farklı catering ihtiyaçları vardır.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {cards.map((card) => (
            <div
              key={card.title}
              className="reveal group bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/60 transition-all duration-300 hover:shadow-lg hover:border-primary-300/40 hover:-translate-y-1"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-xl bg-primary-500/10 border border-primary-500/20 mb-5 transition-all group-hover:bg-primary-500/20 group-hover:border-primary-500/30">
                <i className={`${card.icon} text-2xl md:text-3xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-xl md:text-2xl text-foreground-950 mb-3">
                {card.title}
              </h3>
              <p className="font-body text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
                {card.description}
              </p>
              <button
                onClick={() => onOpenWhatsApp(card.service)}
                className="inline-flex items-center gap-2 font-label text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors"
              >
                Teklif Al
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}